import {
  ApplicationRef,
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {SeoService} from "../shared/services/seo.service";
import {environment} from "../../environments/environment";
import {isPlatformBrowser} from "@angular/common";
import {first, Subscription} from "rxjs";
@Component({
    selector: 'mbnm-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IndexComponent implements OnInit, OnDestroy {

  constructor(private seoService: SeoService,
              @Inject(PLATFORM_ID) private platformId: Object,
              private applicationRef: ApplicationRef,
              private ngZone: NgZone) {
  }

  @ViewChild('heroImage')
  public heroImage: ElementRef;
  public activeContentIndex = 0;
  public firstLoad = true;
  private timer: NodeJS.Timeout;
  private subRef: Subscription;

  public heroContent: Array<any> = [
    {
      tagLine: 'Custom Matboard &amp;<br />Picture Framing',
      paragraph: 'Any <b>size</b>, <b>color</b> and <b>quantity</b>. Unlimited choice, it\'s easier than you think.',
      alt: 'Custom - Any size, color and quantity. Unlimited choice, it\'s easier than you think.',
      actionButton: {
        text: 'START FRAMING',
        url: '/buy/8x10-mat'
      },
      background: {
        xs:       '/assets/images/homepage/custom-picture-framing-sm.jpg',
        'gt-xs':  '/assets/images/homepage/custom-picture-framing.jpg'
      }
    },
    {
      tagLine: 'Fast and Free<br />Shipping',
      paragraph: 'Everything is cut, assembled and shipped from Marietta, GA.',
      alt: 'Fast and Free Shipping. Everything is cut, assembled and shipped from Marietta, GA.',
      actionButton: {
        text: 'BUY NOW',
        url: '/buy/8x10-mat'
      },
      background: {
        xs:       '/assets/images/homepage/fast-shipping-sm.jpg',
        'gt-xs':  '/assets/images/homepage/fast-shipping.jpg'
      }
    },
    {
      tagLine: 'Volume Discounts on<br >Bulk Orders',
      paragraph: 'The more you order, the more you save with <b>no minimums</b> and up to <b>80% off</b>!',
      alt: 'Volume discounts - save with no minimums up to 80% off',
      actionButton: {
        text: 'BUY IN BULK',
        url: '/buy/8x10-mat'
      },
      background: {
        xs:       '/assets/images/homepage/volume-discounts-sm.jpg',
        'gt-xs':  '/assets/images/homepage/volume-discounts.jpg'
      }
    }
  ];

  ngOnInit() {
    this.seoService.setMetaData({
      og: {
        image: environment.baseUrls().site + '/assets/images/logo.png'
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      this.subRef = this.applicationRef.isStable.pipe(first((isStable) => isStable)).subscribe(() => {
        this.resetInterval();
      });
    }
  }

  resetInterval() {
    if (isPlatformBrowser(this.platformId)) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.ngZone.run(() => {
          this.changeActiveIndexBy(1);
        });
      }, 10000);
    }
  }
  setActiveIndex(idx) {
    this.activeContentIndex = idx;
    if (this.activeContentIndex >= this.heroContent.length) this.activeContentIndex = 0;
    if (this.activeContentIndex < 0) this.activeContentIndex = this.heroContent.length - 1;
    this.firstLoad = false;
    this.resetInterval();
  }

  changeActiveIndexBy(delta) {
    this.setActiveIndex(this.activeContentIndex + delta);
  }

  ngOnDestroy() {
    if (this.subRef && !this.subRef.closed) {
      this.subRef.unsubscribe();
    }
  }
}
